var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Panel',{attrs:{"data":_vm.ticket}}),_c('hr'),_c('h3',[_vm._v("Histórico de Multas")]),(_vm.ticket && _vm.ticket.id)?_c('TicketHistories',{attrs:{"ticket":_vm.ticket}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }